import React from "react";
import {submitOnboardingApplication} from "../../../api/OnboardingAPI";
import {useNavigate} from "react-router-dom";

const OnboardingTable = () => {
  const navigate = useNavigate();
  React.useState(() => {
    const id = localStorage.getItem('OnboardApplicationId');
    submitOnboardingApplication(Number(id)).then(() => {
      navigate('/Onboarding', { replace: true })
    });
  });
  
  return <div>
    Loading
  </div>
}

export default OnboardingTable;
